import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class SystemHealthService {

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  getHealthStatus() {
    return this.httpClient.get(`${environment.APP_DIAGNOSTIC_ENDPOINT}/diagnostics_agg`);
    // const studentsObservable = new Observable(observer => {
    //   observer.next(this.testData);
    // });
    // return studentsObservable;
  }

  // Restarts the docker container(s) backing the given camera ROS node(s), e.g.
  // ["camera1"] -> `docker restart cargoeye_camera1_server` on the host.
  // Pass every camera name to restart all of them in one call.
  restartCameras(cameraNames: string[]) {
    return this.httpClient.post(`${environment.SYSTEMINFO_API_ENDPOINT}/cameras/restart`, { cameras: cameraNames });
  }

  getTemperature() {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/temperature`);
  }

  // restartApplication() {
  //   return this.httpClient.get(environment.ROS_DIGNOSTIC_ENDPOINT + 'cargoeye/containers/restart')
  // }

  getAggStatus() {
    return this.httpClient.get(`${environment.AGGREGATOR_API_ENDPOINT}/heartbeat`);
  }
  getDimensionStatus() {
    return this.httpClient.get(`${environment.DIMENSIONING_API_ENDPOINT}/heartbeat`);
  }
  // getMinioStatus() {
  //   // const req = new HttpRequest('GET', environment.MINIO_API_ENDPOINT, {
  //   //   reportProgress: true
  //   // });

  //   // return this.httpClient.request(req);
  //   return this.httpClient.get(environment.MINIO_API_ENDPOINT + "login");
  // }

  getCloudQueueStatus() {

    console.log(`${environment.AGGREGATOR_API_ENDPOINT}`)
    console.log("CLOUD_QUEUE_STALE_DURATION")
    console.log(`${environment.CLOUD_QUEUE_STALE_DURATION}`)
    console.log(`${environment.CLOUD_ENABLE}`)

    return this.httpClient.get(`${environment.AGGREGATOR_API_ENDPOINT}/cloud/queue/heartbeat/staleduration/${environment.CLOUD_QUEUE_STALE_DURATION}`);
  }

}
